module.exports = __webpack_public_path__ + "static/media/agent.4c41e13a.jpg";